import { Button, Icon } from 'admination-react'
import type { ComponentProps } from 'react'

type ModalActionProps = Pick<ComponentProps<typeof Button>, 'onClick' | 'loading' | 'disabled' | 'primaryAction'> & {
  icon: string
  title: string
}

export function ModalAction({ icon, ...props }: ModalActionProps) {
  return (
    <div className="pill">
      <Button type="button" iconOnly {...props}>
        <Icon name={icon} />
      </Button>
    </div>
  )
}
